import { render, staticRenderFns } from "./MarketPlaceChip.vue?vue&type=template&id=3ae6a5e6&scoped=true&"
import script from "./MarketPlaceChip.vue?vue&type=script&lang=js&"
export * from "./MarketPlaceChip.vue?vue&type=script&lang=js&"
import style0 from "./MarketPlaceChip.vue?vue&type=style&index=0&id=3ae6a5e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae6a5e6",
  null
  
)

export default component.exports